import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import "../Modal/Modal.css";
import '../Tables/Table.css';

const modalStyles = {
  color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "40%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
};
const modalStyles_workflow = {
  color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "40%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "black",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
};


function Table(props) {
  const { data, modal, handleClose,rules,type } = props;

  const [parsedrules,setParsedRules]=useState();

  useEffect(() => {

    const filteredRules = JSON.parse(rules).filter(entry => entry.tags.length > 0)
   
    setParsedRules(filteredRules)
  }, [])
  


  return (
    <div>
      <Modal onClose={handleClose} open={modal}  className="Backdrop"  sx={{ width: "300", background: "transparent" }}>
        <Box sx={type==!'workflow'?modalStyles:modalStyles_workflow} >
          <div className="d-flex justify-content-between align-items-center text-light">
            <h2 style={{fontFamily:'Montserrat'}}>Rules</h2>
            <IconButton onClick={handleClose} aria-label="close">
              <CloseIcon className="text-light" />
            </IconButton>
          </div>
          <Tabs >
          <TabList>

            
  {parsedrules && 
  parsedrules.map((entry, index) => (
    entry.tags.length > 0 && ( // Highlighted change: Check if tags array is not empty
      <Tab key={index} style={{listStyle:"none", fontFamily:'Montserrat'}}>
        {entry.strategy.split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ').toUpperCase()}
      </Tab>
    )
  ))}
</TabList>

{parsedrules && parsedrules.length >0 ? ( parsedrules.map((entry, index) => (
        <TabPanel key={index}>
          <div  style={{ maxHeight: '400px', overflowY: 'auto', }}>
          <table className="styled-table" style={{margin:"25px 0px",width: "100%" }}>
            <thead>
              <tr>
                <th>Tag Value</th>
                <th>Tag Description</th>
              {entry.strategy=='fixed_value' && <th>Fixed Value</th>}
              </tr>
            </thead>
            <tbody>
              {entry.tags.map((tag, tagIndex) => (
                <tr key={tagIndex} className="styled-table" style={{width: "100%"}}>
                  <td>{tag.tag_value}</td>
                  <td>{tag.tag_description}</td>
                {tag.hasOwnProperty('fixed_value') && <td>{tag.fixed_value}</td>}
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </TabPanel>
      ))):<div className="d-flex flex-column"><div>No Rules Selected</div> <div
      style={{
        fontFamily: "Montserrat",
        fontSize: "small",
        fontWeight: 400,
        color: "#F9D7A1",
      }}
    >
      By default, we implement a process of anonymizing patient data,
      which involves concealing information that could potentially
      identify a patient. The purpose of this anonymization is to
      safeguard the privacy and confidentiality of patient
      information. We always anonymize the following data tags along
      with the ones selected by you: ProtocolName, PatientName,
      PatientID, PatientBirthDate, PatientBirthTime, PatientAge,
      InstitutionName, AccessionNumber, AdmittingDate,
      DeviceSerialNumber, OperatorsName,
      PerformedProcedureStepStartDate, ReferringPhysicianName,
      PhysiciansOfRecord, StationName, RequestingPhysician,
      PerformingPhysicianName, ScheduledProcedureStepStartDate,
      ScheduledProcedureStepStartTime, AdmissionID, IssuerOfPatientID,
      AdmittingTime, PerformedProcedureStepID,
      PerformedProcedureStepStartTime, RequestedProcedureID,
      RequestedProcedureDescription, ScheduledProcedureStepID,
      ScheduledProcedureStepStartDateTime, SoftwareVersions,
      ContributingEquipmentSequence
    </div></div>}
    </Tabs>
          
        </Box>
      </Modal>
    </div>
  );
}

export default Table;
